import React from 'react'
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton'
import MoreVert from '@material-ui/icons/MoreVert'
import { Link } from '@material-ui/core';
import Popover from 'antd/lib/popover'
import { Link as RouterLink } from 'react-router-dom'
import Constants from '../common/Constants.json'

const ShowButtonsApprovedInstalationsSpa = ({ ...props }) => {
    const { row } = props;
    const { role } = props;

    return (
        <div>
            <Popover
                title=""
                placement="bottomRight"
                trigger="click"
                content={
                    <div>
                        {
                            props.en === 'spa' &&
                            <div>
                                <div>
                                    <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                        Detalle de servicio
                                    </Link>
                                </div>
                                {
                                    (role.includes("Installer") === false || (role.includes("Installer") && role.length > 1)) &&
                                    <div>
                                        <div>
                                            <Link component={RouterLink} to={`/telematics/AsignTechnician/${row.branchOfficeID}&${row.installationOrderId}`}>
                                                Asignar instalador
                                            </Link>
                                        </div>
                                        <div>
                                            <Link component={RouterLink} to={`/telematics/UnasignTechnician/${row.installationOrderId}`}>
                                                Desasignar instalador
                                            </Link>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        {
                            props.en === 'eng' &&
                            <div>
                                <div>
                                    <Link component={RouterLink} to={`/telematics/InstalationDetails/${row.branchOfficeID}&${row.installationOrderId}&${Constants.orderDetailsTelematics.InstallationOrder}`} >
                                        Details
                                    </Link>
                                </div>
                                {
                                    (role.includes("Installer") === false || (role.includes("Installer") && role.length > 1)) &&
                                    <div>
                                        <div>
                                            <Link component={RouterLink} to={`/telematics/AsignTechnician/${row.branchOfficeID}&${row.installationOrderId}`}>
                                                Assign technician
                                            </Link>
                                        </div>
                                        <div>
                                            <Link component={RouterLink} to={`/telematics/UnasignTechnician/${row.installationOrderId}`}>
                                                Unassign technician
                                            </Link>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }>
                <IconButton>
                    <MoreVert />
                </IconButton>
            </Popover>
        </div>
    )
}

const mapStateToProps = state => ({
    role: state.LoginReducer.role,
})

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowButtonsApprovedInstalationsSpa)
